var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserClaimsService } from '../../../services/authentication/user-claims.service';
import { DialogClientService } from '../../../services/basics/dialog-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable } from 'aurelia-templating';
import { autoinject } from "aurelia-dependency-injection";
import { Router } from 'aurelia-router';
import * as Enumerable from 'linq';
import { BindingSignaler } from "aurelia-templating-resources";
var NavigationTabs = /** @class */ (function () {
    function NavigationTabs(router, eventAggregator, dialogClient, userClaimsService, bindingSignaler) {
        this.router = router;
        this.eventAggregator = eventAggregator;
        this.dialogClient = dialogClient;
        this.userClaimsService = userClaimsService;
        this.bindingSignaler = bindingSignaler;
        this.showOriginalTitleOnly = false;
        this.selectedRoute = null;
    }
    NavigationTabs.prototype.navigate = function (event, routes, isFromMain) {
        if (isFromMain === void 0) { isFromMain = false; }
        var route = routes.filter(function (x) { return !(x.isVisible == false); })[0];
        if (route.route[0] == 'support') {
            //then navigate in blank redirection
            window.open('https://support.spinolagaming.com/', '_blank');
        }
        else if (this.userClaimsService.hasPermissions(route.claimsRequired)) {
            var x = "";
            if (Array.isArray(route.route)) {
                x = route.route[0];
            }
            else {
                x = String(route.route);
            }
            this.router.navigate(x + (route.queryString ? route.queryString : ""));
        }
        event.stopPropagation();
    };
    NavigationTabs.prototype.attached = function () {
        var _this = this;
        this.selectedRoute = Enumerable.from(this.routes ? this.routes : this.router.routes).first(function (x) { return _this.router.currentInstruction && x.name == _this.router.currentInstruction.config.name; });
        this.eventAggregator.subscribe("router:navigation:complete", function (response) {
            if (_this.dialogClient.isModalVisible)
                _this.dialogClient.hide();
            //Check if navigation was cancelled
            _this.selectedRoute = Enumerable.from(_this.routes ? _this.routes : _this.router.routes).first(function (x) { return x.name == _this.router.currentInstruction.config.name; });
            _this.bindingSignaler.signal('refresh-is-active');
        });
    };
    NavigationTabs.prototype.isActive = function (menuTab) {
        var _this = this;
        var routes = this.getRoutes(menuTab);
        if (menuTab && this.selectedRoute) {
            return routes.some(function (x) { return x.name == _this.selectedRoute.name; });
        }
        else {
            return false;
        }
    };
    NavigationTabs.prototype.getRoutes = function (menuTab) {
        var routes = [];
        if (menuTab) {
            menuTab.routes.forEach(function (route) {
                routes.push(route);
                if (route.createNewRoute) {
                    routes.push(route.createNewRoute);
                }
                if (route.editRoute) {
                    routes.push(route.editRoute);
                }
            });
        }
        return routes;
    };
    NavigationTabs.prototype.hasIcons = function (menuTab) {
        var routes = [];
        if (menuTab) {
            menuTab.routes.forEach(function (route) {
                routes.push(route);
                if (route.createNewRoute && !(route.createNewRoute.isVisible === false)) {
                    routes.push(route.createNewRoute);
                }
                if (route.editRoute && !(route.editRoute.isVisible === false)) {
                    routes.push(route.editRoute);
                }
            });
        }
        return routes.some(function (x) { return x.icon != null; });
    };
    NavigationTabs.prototype.isVisible = function (menuTab) {
        var routes = this.getRoutes(menuTab);
        return routes.some(function (x) { return x.isVisible == true; });
    };
    NavigationTabs.prototype.moreThanOne = function (menuTab) {
        var routes = this.getRoutes(menuTab).filter(function (x) { return !(x.isVisible == false); });
        return routes.length > 1;
    };
    NavigationTabs.prototype.getRouteName = function (menuTab) {
        if (this.showOriginalTitleOnly)
            return menuTab.title;
        var routes = this.getRoutes(menuTab).filter(function (x) { return !(x.isVisible == false); });
        if (routes.length > 1) {
            return menuTab.title;
        }
        var route = routes[0];
        var claims = [];
        if (route && typeof route.claimsRequired == "function") {
            claims = route.claimsRequired();
        }
        else if (route && typeof route.claimsRequired != "function") {
            claims = route.claimsRequired;
        }
        if (this.userClaimsService.hasPermissions(claims)) {
            return route.title;
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], NavigationTabs.prototype, "menu", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], NavigationTabs.prototype, "routes", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], NavigationTabs.prototype, "showOriginalTitleOnly", void 0);
    NavigationTabs = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router,
            EventAggregator,
            DialogClientService,
            UserClaimsService,
            BindingSignaler])
    ], NavigationTabs);
    return NavigationTabs;
}());
export { NavigationTabs };
